import { render, staticRenderFns } from "./TicketScannerSetup.vue?vue&type=template&id=2358884e&scoped=true&lang=pug&"
import script from "./TicketScannerSetup.vue?vue&type=script&lang=js&"
export * from "./TicketScannerSetup.vue?vue&type=script&lang=js&"
import style0 from "./TicketScannerSetup.vue?vue&type=style&index=0&id=2358884e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2358884e",
  null
  
)

export default component.exports